import { Box, Stack } from "@mui/material"

type LayoutProps = {
    children: React.ReactNode
}
  
const ContentLayout = ({children}:LayoutProps) => (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
        display: "flex",
        justifyContent: "center"
      }}
    >
    <Stack
      direction="column"
      alignItems="flex-center"
      justifyContent="center"
      sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
    >
  
      <Stack
        sx={{ backgroundColor: "primary.light", p: { xs: 2, md: 3 } }}
        spacing={2}
        direction="row"
        alignItems="center"
        justifyContent="center"
        flexWrap={"wrap"}
      >
        {children}
      </Stack>
    </Stack>
    </Box>
  )

  export default ContentLayout